import React, { useState, useEffect, useRef } from "react";

import { DataGrid } from "@material-ui/data-grid";
import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import { GridStyled } from "../../styles/GlobalStyle";
import MaskService from "../../utils/mask/maskService";
import { TitleTable } from "../../components/basic/TitleTable";
import { formatDateBrazilian } from "../../utils/formatDate";
import filterTable from "../../utils/filterTable";
import { VideoAccountantEdit } from "./VideoAccountantEdit";
import { getPortalVideosCustomers } from "../../repositories/v1/portalVideoCustomer";

function VideoAccountantPreview() {
  const [page, setPage] = useState(0);
  const [allRows, setAllRows] = useState([]);
  const [rowsFilter, setRowsFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowEdit, setRowEdit] = useState({});
  const searchRef = useRef(null);

  const columns = [
    {
      field: "Acoes",
      headerName: "Acões",
      width: 80,
      renderCell: ({ row }) => (
        <Tooltip title="Editar Vídeo">
          <IconButton onClick={() => setRowEdit(row)}>
            <EditOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
      align: "center",
    },
    {
      field: "CNPJ",
      headerName: "CNPJ/CPF",
      width: 161,
      renderCell: ({ row }) =>
        MaskService.toMask(
          row?.CNPJ.length > 11 ? "cnpj" : "cpf",
          row?.CNPJ || ""
        ),
    },
    {
      field: "Razao",
      headerName: "Razão",
      minWidth: 250,
      flex: 1,
      renderCell: ({ row }) => row?.Razao,
    },
    {
      field: "Video URL",
      headerName: "Vídeo URL",
      minWidth: 250,
      flex: 1,
      renderCell: ({ row }) => row?.VideoUrl,
    },
    {
      field: "Data",
      headerName: "Data Atualização",
      width: 155,
      renderCell: ({ row }) => formatDateBrazilian(row?.updatedAt, true),
      align: "center",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const { data: respReport } = await getPortalVideosCustomers();

        setAllRows(respReport.data);
        setRowsFilter(respReport.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChangeFilter = (e) => {
    e.preventDefault();

    if (!searchRef?.current?.value) return setRowsFilter(allRows);

    const newArr = filterTable({
      data: allRows,
      text: searchRef?.current?.value,
      columns: ["CNPJ", "Razao", "Fantasia", "VideoUrl"],
    });

    setRowsFilter(newArr);
    setPage(0);
  };

  const handleAddUrl = ({ CNPJ, VideoUrl, updatedAt }) => {
    const indexAll = allRows.findIndex((row) => row.CNPJ === CNPJ);
    const indexFilter = rowsFilter.findIndex((row) => row.CNPJ === CNPJ);

    const copyAllRows = [...allRows];
    copyAllRows[indexAll] = {
      ...copyAllRows[indexAll],
      VideoUrl,
      updatedAt,
    };
    setAllRows(copyAllRows);

    if (indexFilter !== -1) {
      const copyRowsFilter = [...rowsFilter];
      copyRowsFilter[indexFilter] = {
        ...copyRowsFilter[indexFilter],
        VideoUrl,
        updatedAt,
      };
      setRowsFilter(copyRowsFilter);
    }
  };

  return (
    <Container maxWidth="lg">
      {!!rowEdit?.CNPJ && (
        <VideoAccountantEdit
          cnpj={rowEdit.CNPJ}
          reason={rowEdit.Razao}
          videoUrl={rowEdit.VideoUrl}
          handleClose={() => setRowEdit({})}
          handleAddUrl={handleAddUrl}
        />
      )}
      <GridStyled
        container
        padding="20px 0 20px 0"
        justify="space-between"
        spacing={3}
      >
        <Grid item xs={12}>
          <TitleTable
            inputRef={searchRef}
            labelFilter="Filtro (CNPJ, Razão, Fantasia, Vídeo URL)"
            title="Vídeos dos Escritórios"
            handleFilter={handleChangeFilter}
            loading={loading}
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            autoHeight
            disableColumnMenu
            loading={loading}
            rows={rowsFilter}
            columns={columns}
            pageSize={10}
            getRowId={(row) => row.CNPJ}
            page={page}
            onPageChange={(e) => setPage(e?.page || 0)}
          />
        </Grid>
      </GridStyled>
    </Container>
  );
}

export { VideoAccountantPreview };
